<style lang="stylus">
        .recycle-container
            position relative
            height calc(100% - 50px)
            page_background()
            flex 1
            padding $indexContainerPadding
            padding-top 30px
            user-select none
            &.isTeamsApp
                @media screen and (max-width: 500px)
                    padding 12px 0 0 15px
                    .switch-view
                        display none
            &.recycle-container-pc
                padding 12px 0 0 40px
                .filter-box
                    top 12px !important

            .recycleWarn-tips
                margin-bottom 16px

            .emptyCloud
                font-size 13px
                position absolute
                top 224px
                left 50%
                transform translate(-50%,0)
                span
                    color #222
                    margin-bottom 8px
                .emptyCloud-viptip
                    font-size 14px
                    color #222
                .emptyCloud-tovip
                    color #FF7100 !important
                    cursor pointer
                    &:hover
                        text-decoration underline

            .files-title
                margin-bottom: 5px

            .recycle-list-header
                .file-time
                    width 15%
                .file-size
                    width 15%
                .file-notes
                    width 20%
                    display flex
                    align-items center
                    white-space nowrap
                    font-size 14px
                    text-indent 15px

    .home-container
        .recycle-container
            .filter-box
                top 30px
</style>

<template>
    <div
        class="recycle-container"
        :class="{
            'dark-theme__workbench': isPCDarkMode == 2,
            isTeamsApp: isTeamsApp,
            'recycle-container-pc': isPC && internal,
        }"
        ref="rootDom"
        @click="clear()"
        @mousedown="toSelect"
    >
        <!-- <div class="recycle-btn-box">
            <div class="recycle-all" @click="recycleAll()">{{$t('restore')}}</div>
            <div class="recycle-clear" @click="recycleClear()">{{$t('clear')}}</div>
        </div> -->
        <RightMenu
            v-if="folderMenuBoxShow"
            :style="{ top: top + 'px', left: left + 'px' }"
            :menuList="menuList"
            @handleClicks="handleClickFolder($event)"
        />
        <RightMenu
            v-if="contextmenuBoxShow"
            :style="{ top: top + 'px', left: left + 'px' }"
            :menuList="menuList"
            @handleClicks="handleClickFlie($event)"
        />

        <WbHeader :from="'recycle'" :outside="true" @wbHeaderEvent="wbHeaderEvent" />
        <div class="filter-box">
            <div class="search-box">
                <input
                    autocomplete="off"
                    spellcheck="false"
                    type="text"
                    v-model="searchValue"
                    :placeholder="$t('search')"
                    @keypress="enter($event)"
                />
                <button class="search-icon" @click="search()">
                    <iconSymbol :name="'fileSearchIcon'" />
                </button>
            </div>
            <div class="order-box" v-if="!searchMode && layoutMode != 'list'">
                <div>
                    <Dropdown trigger="click" @on-click="setOrder">
                        <a href="javascript:void(0)">{{ $t(orderName) }}</a>
                        <DropdownMenu slot="list">
                            <DropdownItem name="name">{{ $t("name") }}</DropdownItem>
                            <DropdownItem name="time">{{ $t("time") }}</DropdownItem>
                            <DropdownItem name="size">{{ $t("size") }}</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </div>
                <iconSymbol :name="'orderIcon'" :style="{ transform: 'rotate(' + (rotate + 180) + 'deg)' }" @click.native="order()"></iconSymbol>
            </div>
            <div class="button-box" :title="$t('reAll')" @click="recycleAllConfirm()">
                <iconSymbol :name="'restoreIcon'"></iconSymbol>
            </div>
            <div class="button-box" :title="$t('reClear')" @click="recycleClearConfirm()">
                <iconSymbol :name="'deleteIcon'"></iconSymbol>
            </div>
            <div class="button-box switch-view" @click="setLayout()" :title="$t('switchView')">
                <iconSymbol :name="layoutMode == 'list' ? 'gridViewIcon' : 'listViewIcon'"></iconSymbol>
            </div>
        </div>

        <RecycleWarn v-if="showRecycleWarn" class="recycleWarn-tips" />

        <FilesSelector
            v-if="mulSelectMode"
            :type="'recycle'"
            :totalNum="activeList.length"
            :fileNum="selectFilesIndex.length"
            :s_margin="s_margin"
            @selectAllFiles="selectAllFiles"
            @cancelSelect="cancelSelect"
            @delFiles="delFile"
            @recycleFiles="recycleFile"
        />
        <div v-if="layoutMode == 'list' && !searchMode" class="list-header recycle-list-header">
            <div class="file-name" @click="clickOrder('name')">
                <span>{{ $t("name") }}</span>
                <div class="icon-con">
                    <iconSymbol
                        :class="{ 'active-icon': orderName == 'name' && rotate == 180 }"
                        style="transform: rotate(180deg)"
                        :name="'fileUpIcon'"
                    ></iconSymbol>
                    <iconSymbol :class="{ 'active-icon': orderName == 'name' && rotate == 0 }" :name="'fileUpIcon'"></iconSymbol>
                </div>
            </div>
            <div class="file-time" @click="clickOrder('time')">
                <span>{{ $t("time") }}</span>
                <div class="icon-con">
                    <iconSymbol
                        :class="{ 'active-icon': orderName == 'time' && rotate == 180 }"
                        style="transform: rotate(180deg)"
                        :name="'fileUpIcon'"
                    ></iconSymbol>
                    <iconSymbol :class="{ 'active-icon': orderName == 'time' && rotate == 0 }" :name="'fileUpIcon'"></iconSymbol>
                </div>
            </div>
            <div class="file-size" @click="clickOrder('size')">
                <span>{{ $t("size") }}</span>
                <div class="icon-con">
                    <iconSymbol
                        :class="{ 'active-icon': orderName == 'size' && rotate == 180 }"
                        style="transform: rotate(180deg)"
                        :name="'fileUpIcon'"
                    ></iconSymbol>
                    <iconSymbol :class="{ 'active-icon': orderName == 'size' && rotate == 0 }" :name="'fileUpIcon'"></iconSymbol>
                </div>
            </div>
            <div class="file-notes">
                <span>{{ $t("notes") }}</span>
            </div>
        </div>
        <div class="files-scroll" :style="{ height: scrollboxHeight }" @scroll="clear" ref="filesScroll">
            <div class="show-thumbnail" :style="{ top: thumbnail.top + 'px', left: thumbnail.left + 'px' }" v-if="thumbnail.state">
                <img :src="thumbnail.src" alt="" @error="coverError($event)" />
            </div>
            <div
                class="emptyCloud"
                v-cloak
                v-if="userInfo && !pcNoLogin && showNoRecycleTips && folderList && filesList && folderList.length == 0 && filesList.length == 0"
            >
                <img src="@/home/assets/img/null-icon/default-null.svg" alt="" />
                <span>{{ $t("notTem") }}</span>
                <div class="emptyCloud-viptip" v-if="!vip">
                    <p>
                        {{ $t("noVipLimit") }}
                        <span class="emptyCloud-tovip" @click="toVip">{{ $t("noVipLimitToBuy") }}</span>
                    </p>
                </div>
            </div>
            <pclogin />
            <template v-if="layoutMode == 'grid'">
                <div class="files-folders" v-if="!searchMode && folderList.length > 0">
                    <div
                        class="folder-item"
                        :class="{ 'file-item-active': index == selectFolderIndex }"
                        v-for="(item, index) in folderList"
                        :key="index"
                        @contextmenu.prevent="editFolder($event, item, index)"
                        @click="selectFloder(item, index)"
                        @dragover.prevent
                    >
                        <!-- @drop="drop(item)"
                    @dragenter="dragenter(item, index)"
                    @dragleave="dragleave(item, index)" -->
                        <!-- <img :src="require('@/home/assets/img/files/folder.svg')"> -->
                        <iconSymbol class="folder-icon" :name="'folderIcon'" />
                        <div class="folder-text" :title="item.name">{{ item.name }}</div>
                        <!-- <input type="text" class="folder-rename" v-model="renameValue" v-if="folderRenameShow==index" @blur="renameFolder()"> -->
                        <iconSymbol :name="'folderMenuIcon'" class="folder-menu" @click.stop.native="editFolder($event, item, index)" />
                    </div>
                </div>
                <div class="files-box" ref="filesBoxList">
                    <gridFile
                        v-for="(item, index) in activeList"
                        :key="(searchMode ? 'search-' : 'file-') + index"
                        :type="'recycle'"
                        @mousedown.native.prevent="clearFolder"
                        :index="index"
                        :mulSelectMode="mulSelectMode"
                        :file="item"
                        @enterMulSelectMode="mulSelectMode = true"
                        @cancelMulSelectMode="mulSelectMode = false"
                    />
                </div>
            </template>
            <template v-if="layoutMode == 'list'">
                <div class="list-cons">
                    <div v-if="!searchMode" class="files-folders-list">
                        <div
                            class="folder-item"
                            v-for="(item, index) in folderList"
                            :class="{ 'file-item-active': index == selectFolderIndex }"
                            @click="selectFloder(item, index)"
                            :key="index"
                            @contextmenu.prevent="editFolder($event, item, index)"
                        >
                            <!-- @mouseenter="folderEnter(index)" -->
                            <!-- @mouseleave="folderLeave()" -->
                            <!-- @dblclick="openFolder(item)" -->

                            <iconSymbol :name="'folderIcon'" />
                            <!-- <img :src="require('@/home/assets/img/files/folder-list.svg')" @error="listcoverError($event)"> -->
                            <div class="folder-text" style="">{{ item.name }}</div>
                            <!-- <input type="text" class="folder-rename" v-model="renameValue" v-if="folderRenameShow==index" @blur="renameFolder()"> -->
                        </div>
                    </div>

                    <div class="files-box-list" ref="filesBoxList">
                        <listFile
                            v-for="(item, index) in activeList"
                            :key="searchMode ? 'search-' : 'file-' + index"
                            :type="'recycle'"
                            :mode="searchMode ? 'search' : 'files'"
                            @mousedown.native.prevent="clearFolder"
                            :index="index"
                            :mulSelectMode="mulSelectMode"
                            :file="item"
                            @enterMulSelectMode="mulSelectMode = true"
                            @cancelMulSelectMode="mulSelectMode = false"
                        />
                    </div>
                </div>
            </template>
            <div class="files-box-multiDrag" v-show="dragFlag" :style="{ left: `${dragImgLeft}px`, top: `${dragImgTop}px` }">
                <p class="multiDrag-text">{{ selectFilesIndex.length }}</p>
                <iconSymbol class="multiDrag-svg" :name="'eddxFileIcon'" />
                <!-- <div class="" :style="{'background-Image': `url(${require('@/home/assets/img/files/file.svg')})`}"></div> -->
            </div>
            <div
                class="files-box-selectArea"
                ref="selectArea"
                :style="{
                    left: `${dragSelectLeft}px`,
                    top: `${dragSelectTop}px`,
                    width: `${dragSelectWidth}px`,
                    height: `${dragSelectHeight}px`,
                }"
                v-show="showDragSelect"
            ></div>
        </div>
        <!-- <div class="files-folders">
            <div class="folder-item" v-for="(item, index) in folderList" :key="index">
                <img :src="require('@/home/assets/img/files/folder.svg')">
                <div class="folder-text" style="">{{item.name}}</div>
                <img :src="require('@/home/assets/img/files/menu.svg')" class="folder-menu" @click.stop="editFolder($event, item, index)"/>
            </div>

        </div>
        <div class="files-box">
            <div class="files-item"
            v-for="(item, index) in filesList"
            :key="index"
            @contextmenu.prevent="contextmenu($event, item, index)"
            >

                <img :src="item.info ? onlineFilesImg(item.info.img,item.info.down_exp,item.info.img_down_sign,item.lastModified) : require('@/home/assets/img/files/default-files.svg')" @error="coverError($event)">
                <span>{{item.name}}</span>
            </div>
        </div>
        <div class="empty-tip" v-if="showNoRecycleTips">{{$t("notTem")}}</div> -->
    </div>
</template>

<script lang="ts">
    import naturalsort from "javascript-natural-sort";

    naturalsort.insensitive = true;
    import { Component, Prop, Vue, Mixins, Watch } from "vue-property-decorator";
    import fileItem from "./fileItem";
    import gridFile from "./gridFile.vue";
    import listFile from "./listFile.vue";
    import FilesSelector from "./FilesSelector.vue";
    import pclogin from "@/home/parts/pclogin.vue";
    import RightMenu from "./RightMenu.vue";
    import WbHeader from "./Wb-header.vue";
    import RecycleWarn from "@/home/parts/vip/recycleWarn.vue";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            fileItem,
            gridFile,
            listFile,
            FilesSelector,
            pclogin,
            RightMenu,
            WbHeader,
            RecycleWarn,
        },
    })
    export default class Recycle extends Mixins(fileItem) {
        folderList = [];
        filesList = [];
        searchList = [];
        searchValue = "";
        get searchMode() {
            return this.$store.state.recycle.searchMode;
        }
        set searchMode(v) {
            this.$store.commit("setRecycleStatus", {
                searchMode: v,
            });
        }
        wbHeaderEvent(obj) {
            let instance = this;
            let func = instance && obj.func_name ? instance[obj.func_name] : null;
            func && func(obj.args);
        }
        get showRecycleWarn() {
            return this.folderList.length !== 0 || this.filesList.length !== 0;
        }
        get showVIP() {
            // 记录当前选中文件是否含有超时文件
            let flag = false;
            for (let i = 0; i < this.selectFilesIndex.length; i++) {
                if (this.activeList[this.selectFilesIndex[i]].remain_time <= 83) {
                    flag = true;
                    break;
                }
            }
            return flag && !this.vip;
        }
        // mulSelect
        mulSelectMode = false;
        get menuList() {
            return [
                { key: 0, label: this.$t("recover"), showVip: this.showVIP },
                { key: 1, label: this.$t("del") },
            ];
        }
        get scrollboxHeight() {
            let selectorH = 46; // 多选工具栏高度
            let pathTitle = 43;
            let listHeadH = 64; // 列表头高度 含margin-b
            let selectorMarginT = this.isPC ? 20 : this.searchMode ? 0 : 0; // 多选工具栏margin-top
            let selectorMarginB = this.isPC ? 10 : 16; // 多选工具栏margin-bottom
            let baseHeight = this.mulSelectMode ? selectorH + selectorMarginT + selectorMarginB : 0; // 多选工具栏整体高度
            let recycleWarnHeight = this.showRecycleWarn ? 48 : 0;
            let allHeight = baseHeight + pathTitle + recycleWarnHeight;
            if (this.layoutMode == "list") {
                return this.searchMode ? `calc(100% - ${allHeight}px)` : `calc(100% - ${allHeight + listHeadH}px)`;
            } else {
                return this.searchMode ? `calc(100% - ${allHeight}px)` : `calc(100% - ${allHeight}px)`;
            }
        }
        get s_margin() {
            if (this.isPC) {
                return this.searchMode ? "20px 96px 10px 0" : "20px 96px 10px 0";
            } else {
                return "0 40px 16px 0";
            }
        }

        handleClickFolder(key) {
            // 仅存在两种情况，用 0 1 区分
            if (this.showVIP && !key) {
                this.$openBuyPage("recycleTimeResore");
                return;
            }
            key ? this.delFolder() : this.recycleFolder();
        }
        handleClickFlie(key) {
            // 仅存在两种情况，用 0 1 区分
            if (this.showVIP && !key) {
                this.$openBuyPage("recycleTimeResore");
                return;
            }
            key ? this.delFile() : this.recycleFile();
        }
        selectAllFiles(type) {
            if (!type) {
                this.clearFile(1);
            } else {
                let arr = [];
                for (let i = 0; i < this.activeList.length; i++) {
                    arr.push(i);
                }
                this.$store.commit("setState", {
                    type: "selectFilesIndex",
                    data: arr,
                });
            }
        }
        cancelSelect() {
            this.clearFile();
        }

        get activeList() {
            return this.searchMode ? this.searchList : this.filesList;
        }
        get pcNoLogin() {
            return this.isPC && !this.params.islogin;
        }
        toPCLogin() {
            (<any>window).$qt.jsCallUserLogin();
        }
        get userInfo() {
            return this.$store.state.userInfo;
        }
        @Watch("userInfo.islogin")
        onLoginChanged(val, oldval) {
            if (this.isPC) {
                if (val && !oldval) {
                    this.getRecycleList();
                    this.$bus.$emit("pcLoginEvenvt");
                } else if (!val && oldval) {
                    this.filesList = [];
                    this.folderList = [];
                    this.searchList = [];
                }
            }
        }

        get layoutMode() {
            return this.$store.state.layoutMode;
        }
        set layoutMode(v) {
            this.$store.commit("setState", {
                type: "layoutMode",
                data: v,
            });
        }
        get top() {
            return this.$store.state.layoutTop;
        }
        set top(v) {
            this.$store.commit("setState", {
                type: "layoutTop",
                data: v,
            });
        }
        get left() {
            return this.$store.state.layoutLeft;
        }
        set left(v) {
            this.$store.commit("setState", {
                type: "layoutLeft",
                data: v,
            });
        }
        get folderMenuBoxShow() {
            return this.$store.state.folderContextShow;
        }

        set folderMenuBoxShow(v) {
            this.$store.commit("setState", {
                type: "folderContextShow",
                data: v,
            });
        }

        get contextmenuBoxShow() {
            return this.$store.state.fileContextShow;
        }

        set contextmenuBoxShow(v) {
            this.$store.commit("setState", {
                type: "fileContextShow",
                data: v,
            });
        }
        get selectFilesIndex() {
            return this.$store.state.selectFilesIndex;
        }
        set selectFilesIndex(v) {
            this.$store.commit("setState", {
                type: "selectFilesIndex",
                data: v,
            });
        }
        selectFolder = null;
        selectFolderIndex = null;

        isOperating = false;
        showNoRecycleTips = false;

        showDragSelect = false; // 显示拖选框
        dragSelectLeft = 0;
        dragSelectTop = 0;
        dragSelectWidth = 0;
        dragSelectHeight = 0;

        dragFlag = false; // 进入拖拽item模式
        dragImgLeft = 0;
        dragImgTop = 0;
        dragItemList = [];

        rotate = localStorage.getItem("max_order") || 0;
        orderName = localStorage.getItem("max_sort") || "time";

        clickOrder(name) {
            let change = name !== this.orderName;
            this.setOrder(name);
            if (!change) {
                this.order();
            }
        }

        setOrder(name) {
            this.orderName = name;
            if (name === "time") {
                if (this.rotate == 180) {
                    this.filesList = this.filesList.sort((a, b) => new Date(a.deleted_at).getTime() - new Date(b.deleted_at).getTime());
                } else {
                    this.filesList = this.filesList.sort((a, b) => new Date(b.deleted_at).getTime() - new Date(a.deleted_at).getTime());
                }
            } else if (name === "size") {
                if (this.rotate == 180) {
                    this.filesList = this.filesList.sort((a, b) => a.size - b.size);
                } else {
                    this.filesList = this.filesList.sort((a, b) => b.size - a.size);
                }
            } else if (name === "name") {
                if (this.rotate == 0) {
                    this.filesList = this.filesList.sort((a, b) => naturalsort(a.name, b.name));
                    this.folderList = this.folderList.sort((a, b) => naturalsort(a.name, b.name));
                } else {
                    this.filesList = this.filesList.sort((a, b) => naturalsort(b.name, a.name));
                    this.folderList = this.folderList.sort((a, b) => naturalsort(b.name, a.name));
                }
            } else {
                this.orderName = "time";
                if (this.rotate == 180) {
                    this.filesList = this.filesList.sort((a, b) => new Date(a.deleted_at).getTime() - new Date(b.deleted_at).getTime());
                } else {
                    this.filesList = this.filesList.sort((a, b) => new Date(b.deleted_at).getTime() - new Date(a.deleted_at).getTime());
                }
            }
            localStorage.setItem("max_sort", this.orderName);
        }
        searchBack() {
            this.searchMode = false;
            this.searchValue = "";
        }
        order() {
            this.$track("recycle", "sort file");
            if (this.rotate == 0) {
                this.rotate = 180;
                if (this.orderName == "name") {
                    this.filesList = this.filesList.sort((a, b) => naturalsort(b.name, a.name));
                    this.folderList = this.folderList.sort((a, b) => naturalsort(b.name, a.name));
                } else if (this.orderName == "time") {
                    this.filesList = this.filesList.sort((a, b) => new Date(a.deleted_at).getTime() - new Date(b.deleted_at).getTime());
                } else if (this.orderName == "size") {
                    this.filesList = this.filesList.sort((a, b) => a.size - b.size);
                }
            } else {
                this.rotate = 0;
                if (this.orderName == "name") {
                    this.filesList = this.filesList.sort((a, b) => naturalsort(a.name, b.name));
                    this.folderList = this.folderList.sort((a, b) => naturalsort(a.name, b.name));
                } else if (this.orderName == "time") {
                    this.filesList = this.filesList.sort((a, b) => new Date(b.deleted_at).getTime() - new Date(a.deleted_at).getTime());
                } else if (this.orderName == "size") {
                    this.filesList = this.filesList.sort((a, b) => b.size - a.size);
                }
            }
            localStorage.setItem("max_order", this.rotate.toString());
        }
        toSelect(e) {
            console.log(e.target);
            if (e.target.className && e.target.className.indexOf) {
                if (
                    e.target.className.indexOf("files-scroll") != -1 ||
                    e.target.className.indexOf("files-box") != -1 ||
                    e.target.className.indexOf("files-folders") != -1 ||
                    e.target.className.indexOf("list-cons") != -1 ||
                    e.target.className.indexOf("files-container") != -1
                ) {
                    // 框选
                    this.dragSelect(e);
                }
            }
        }
        clearFile(keepMulSelectMode = 0) {
            this.selectFilesIndex = [];
            !keepMulSelectMode && (this.mulSelectMode = false);
        }
        clearFolder() {
            this.selectFolderIndex = null;
            this.selectFolder = null;
        }
        dragSelect(e) {
            // 框选
            if (e.buttons != 1) return;
            let dom = this.$refs.selectArea as HTMLElement,
                rootDom = this.$refs.rootDom as HTMLElement,
                scrollDom = this.$refs.filesScroll as HTMLElement,
                filesBoxListDom = this.$refs.filesBoxList as HTMLElement,
                parentInfo = scrollDom.getBoundingClientRect(),
                parentL = parentInfo["x"],
                parentT = parentInfo["y"],
                baseL = e.clientX,
                baseT = e.clientY,
                baseScroll = scrollDom.scrollTop,
                lineCount = 0,
                itemboxW = 0,
                itemboxH = 0,
                itemMarginR = 0,
                itemMarginB = 0,
                outSideFile = false,
                outSideScTop = 0,
                outSideTop = 0;
            console.log(1234);
            if (!scrollDom.contains(e.target)) {
                outSideFile = true;
                outSideTop = parentT - baseT;
                outSideScTop = scrollDom.scrollTop;
            }

            if (filesBoxListDom?.children?.length > 0) {
                let target = filesBoxListDom.children[0];
                let postionInfo = target.getBoundingClientRect();
                let styleInfo = getComputedStyle(target);
                itemMarginR = parseFloat(styleInfo["marginRight"].replace(/[^\d]/g, ""));
                itemMarginB = parseFloat(styleInfo["marginBottom"].replace(/[^\d]/g, ""));
                itemboxW = postionInfo["width"];
                itemboxH = postionInfo["height"];
            }

            if (filesBoxListDom) {
                lineCount = Math.floor(filesBoxListDom.getBoundingClientRect()["width"] / (itemboxW + itemMarginR));
            }

            this.dragSelectLeft = baseL - parentL;
            this.dragSelectTop = baseT - parentT < 0 ? 0 : baseT - parentT;

            document.onmousemove = (ev: MouseEvent) => {
                if (ev.clientX - e.clientX == 0 || ev.clientY - e.clientY == 0) return;
                this.clearFile(1);
                if (!scrollDom.contains(ev.target as HTMLElement)) {
                    this.dragSelectWidth = 0;
                    this.dragSelectHeight = 0;
                    return;
                }
                this.showDragSelect = true;

                let moveL = ev.clientX,
                    moveT = ev.clientY,
                    xOffset = moveL - baseL,
                    yOffset = moveT - baseT,
                    scrollT = scrollDom.scrollTop - baseScroll;
                if (xOffset <= 0) {
                    this.dragSelectLeft = moveL - parentL;
                    this.dragSelectWidth = -xOffset;
                } else {
                    this.dragSelectLeft = baseL - parentL - 1;
                    this.dragSelectWidth = xOffset - 1;
                }
                if (yOffset + scrollT <= 0) {
                    if (outSideFile) {
                        this.dragSelectTop = outSideScTop;
                        this.dragSelectHeight = -yOffset - scrollT - outSideTop;
                    } else {
                        this.dragSelectTop = moveT - parentT + baseScroll + scrollT;
                        this.dragSelectHeight = -yOffset - scrollT;
                    }
                } else {
                    if (outSideFile) {
                        this.dragSelectTop = outSideScTop;
                        this.dragSelectHeight = yOffset - 1 + scrollT - outSideTop;
                    } else {
                        this.dragSelectTop = baseT - parentT + baseScroll - 1;
                        this.dragSelectHeight = yOffset - 1 + scrollT;
                    }
                }
                addToActive();
            };
            document.onmouseup = () => {
                if (!this.showDragSelect) this.clearFile();
                this.showDragSelect && this.selectFilesIndex.length > 0 && (this.mulSelectMode = true);
                this.showDragSelect = false;
                document.onmousemove = null;
                document.onmouseup = null;
            };
            let addToActive = () => {
                if (this.layoutMode == "list") {
                    let arr = [];
                    let startH = outSideFile ? outSideScTop : dom.offsetTop,
                        start = startH - filesBoxListDom.offsetTop,
                        end = this.dragSelectHeight;

                    if (itemboxH == 0) return;
                    let startIndex = start < 0 ? 0 : Math.floor(start / itemboxH),
                        endIndex = Math.floor((start + end) / itemboxH);
                    if (endIndex >= this.filesList.length) {
                        endIndex = this.filesList.length - 1;
                    }
                    for (let i = startIndex; i <= endIndex; i++) {
                        arr.push(i);
                    }
                    this.$store.commit("setState", {
                        type: "selectFilesIndex",
                        data: arr,
                    });
                } else {
                    let arr = [],
                        startX = dom.offsetLeft - filesBoxListDom.offsetLeft,
                        startY = dom.offsetTop - filesBoxListDom.offsetTop,
                        endX = startX + this.dragSelectWidth,
                        endY = startY + this.dragSelectHeight;

                    let xIndexStart = Math.floor((startX + itemMarginR) / (itemboxW + itemMarginR)),
                        yIndexStart = Math.floor((startY + itemMarginB) / (itemboxH + itemMarginB)),
                        xIndexEnd = Math.floor(endX / (itemboxW + itemMarginR)),
                        yIndexEnd = Math.floor(endY / (itemboxH + itemMarginB));

                    if (itemboxW + itemMarginR == 0 || itemboxH + itemMarginB == 0) return;
                    xIndexEnd = xIndexEnd > lineCount - 1 ? lineCount - 1 : xIndexEnd; // 鼠标超出有效范围取每行个数-1的值
                    // console.log(xIndexStart, xIndexEnd, yIndexStart,yIndexEnd)
                    console.log(xIndexEnd, xIndexStart);
                    if (
                        xIndexEnd < xIndexStart ||
                        yIndexEnd < yIndexStart ||
                        (xIndexStart < 0 && xIndexEnd < 0) ||
                        (yIndexStart < 0 && yIndexEnd < 0)
                    ) {
                        return;
                    } else {
                        if (yIndexStart < 0) yIndexStart = 0;
                        if (xIndexStart < 0) xIndexStart = 0;
                        for (let i = yIndexStart; i <= yIndexEnd; i++) {
                            for (let j = xIndexStart; j <= xIndexEnd; j++) {
                                if (i * lineCount + j >= this.filesList.length) {
                                    break;
                                }
                                arr.push(i * lineCount + j);
                            }
                        }
                    }
                    console.log(arr);
                    this.$store.commit("setState", {
                        type: "selectFilesIndex",
                        data: arr,
                    });
                }
            };
        }
        selectFloder(item, index) {
            this.clearFile();
            this.selectFolderIndex = index;
            this.selectFolder = item;
        }
        getRecycleList() {
            this.$store.commit("setState", { data: true, type: "showLoading" });
            this.$store
                .dispatch("getRecycleData")
                .then((res) => {
                    let folderList = [];
                    let filesList = [];
                    let objects = res.data.data.objects || [];
                    objects.forEach((item) => {
                        if (item.object_type == "file") {
                            filesList.push(item);
                        } else if (item.object_type == "folder") {
                            folderList.push(item);
                        }
                    });

                    folderList.map((item) => {
                        if (this.isPrivate) {
                            item.name = item.src;
                        } else {
                            let list = item.src.split("/");
                            item.name = list[list.length - 2];
                        }
                    });
                    if (this.isPrivate) {
                        filesList = filesList.map((item) => {
                            item.name = item.path;
                            return item;
                        });
                    } else {
                        filesList = filesList.filter((item) => {
                            if (item.src.match(/.+eddx$/)) {
                                let list = item.src.split("/");
                                let name = list[list.length - 1];
                                name = name.match(/(.*)\.eddx/) && name.match(/(.*)\.eddx/)[1];
                                item.name = name;
                                return true;
                            }
                            return false;
                        });
                    }
                    this.folderList = folderList;
                    this.filesList = filesList;
                    this.setOrder(this.orderName);
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    if (this.folderList.length == 0 && this.filesList.length == 0) {
                        this.showNoRecycleTips = true;
                        // (<any>this).$edMessage.success(this.$t("notTem"))
                    }
                })
                .catch((err) => {
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                });
        }

        enter(e) {
            if (e.keyCode == 13) {
                this.search();
            }
        }

        search() {
            if (this.searchValue) {
                this.$track("recycle", "search file");
                this.searchMode = true;
                this.searchList = [];
                this.$store.commit("setState", { data: true, type: "showLoading" });
                this.searchValue = this.searchValue.trim();
                this.searchList = this.filesList.filter((item) => {
                    return item.name.toLowerCase().includes(this.searchValue.toLowerCase());
                });
                if (this.searchList.length == 0) {
                    (<any>this).$edMessage.error(this.$t("notFind"));
                }
                this.$store.commit("setState", { data: false, type: "showLoading" });
            } else {
                this.searchMode = false;
            }
        }
        setLayout() {
            this.$track("recycle", "toggle layout");
            this.$store.commit("changeLayout");
            this.clearFile();
            this.clearFolder();
        }

        coverError(e) {
            let lang = this.lang == "zh" ? "zh" : "en";
            e.target.src = require(`@/home/assets/img/files/default-files-${lang}.svg`);
        }

        editFolder(e, item, index) {
            this.top = e.pageY + document.querySelector(".recycle-container").scrollTop;
            this.left = e.pageX;
            this.contextmenuBoxShow = false;
            this.folderMenuBoxShow = true;
            this.selectFolderIndex = index;
            this.selectFolder = item;
        }

        // contextmenu (e, files, index) {
        //     this.top = e.pageY
        //     this.left = e.pageX
        //     if (document.documentElement.clientHeight - e.pageY < 200) {
        //         this.top -= 76
        //     }
        //     if (document.documentElement.clientWidth - e.pageX < 200) {
        //         this.left -= 117
        //     }
        //     this.folderMenuBoxShow = false
        //     this.contextmenuBoxShow = true
        //     this.selectFiles = files
        //     this.selectFilesIndex = index
        // }
        get selFiles() {
            return this.filesList.filter((_, i) => {
                return this.selectFilesIndex.includes(i);
            });
        }

        clear() {
            this.folderMenuBoxShow = false;
            this.contextmenuBoxShow = false;
        }

        recycleFolder() {
            if (this.isOperating) return;
            this.$track("recycle", "recycle folder");
            this.isOperating = true;
            this.$store.commit("setState", { data: true, type: "showLoading" });
            this.$store
                .dispatch("recycleFolder", {
                    id: this.selectFolder.id,
                    platform: this.isPC ? "pc" : "web",
                })
                .then((res) => {
                    console.log(res.data);
                    this.isOperating = false;
                    this.folderList.splice(this.selectFolderIndex, 1);
                    this.clearFolder();
                    if (this.folderList.length == 0 && this.filesList.length == 0) {
                        this.showNoRecycleTips = true;
                    }
                    (<any>this).$edMessage.success(this.$t("recSuccess"));
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                })
                .catch((err) => {
                    this.isOperating = false;
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    if (err == "overLimit") {
                        (<any>this).$edMessage.warning(this.$t("fileLimit"));
                        if (this.isPC) {
                            (<any>window).$qt.jsCallUpdateUpgradeTrigger && (<any>window).$qt.jsCallUpdateUpgradeTrigger("cloudFileNumberLimit");
                            (<any>window).$qt.jsCallNewUpgradeToPremium && (<any>window).$qt.jsCallNewUpgradeToPremium(3);
                            (<any>window).$qt.jsCallUpgradeToPremium && (<any>window).$qt.jsCallUpgradeToPremium(3);
                            (<any>window).$qt.jsCallUploadfailReason && (<any>window).$qt.jsCallUploadfailReason("exceedsCloudFileNumber");
                        } else {
                            this.$store.commit("toPublicStatus", {
                                type: "showUpgrade",
                                data: "fileNum",
                            });
                        }
                    }
                });
        }

        delFolder() {
            if (this.isOperating) return;
            this.$track("recycle", "delete folder");
            this.isOperating = true;
            this.$store.commit("setState", { data: true, type: "showLoading" });
            this.$store
                .dispatch("delRecycleFolder", {
                    id: this.selectFolder.id,
                    platform: this.isPC ? "pc" : "web",
                })
                .then((res) => {
                    this.isOperating = false;
                    this.folderList.splice(this.selectFolderIndex, 1);
                    this.clearFolder();
                    if (this.folderList.length == 0 && this.filesList.length == 0) {
                        this.showNoRecycleTips = true;
                    }
                    (<any>this).$edMessage.success(this.$t("delSuccess"));
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    this.$bus.$emit("getStorage"); // 刷新使用空间
                })
                .catch((err) => {
                    this.isOperating = false;
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                });
        }

        recycleFile() {
            if (this.isOperating) return;
            this.$track("recycle", "recycle file");
            this.isOperating = true;
            this.$store.commit("setState", { data: true, type: "showLoading" });
            let delSuccess = [];
            let ids = [];
            let fileKeys = [];
            for (let i = 0; i < this.selectFilesIndex.length; i++) {
                if (this.isPrivate) {
                    ids.push(this.activeList[this.selectFilesIndex[i]].id);
                    fileKeys.push(this.activeList[this.selectFilesIndex[i]].file_key);
                } else {
                    ids.push(this.activeList[this.selectFilesIndex[i]].info.recycle_id);
                }
                delSuccess.push(this.selectFilesIndex[i]);
            }
            this.$store
                .dispatch("recycleFolderBatch", {
                    ids,
                    fileKeys,
                    platform: this.isPC ? "pc" : "web",
                })
                .then((res) => {
                    this.isOperating = false;
                    if (this.searchMode) {
                        this.searchList = this.activeList.filter((v, k) => !ids.includes(v.id));
                        this.filesList = this.filesList.filter((v, k) => !ids.includes(v.id));
                    } else {
                        this.filesList = this.activeList.filter((v, k) => !ids.includes(v.id));
                    }
                    this.clearFile();
                    if (this.folderList.length == 0 && this.filesList.length == 0) {
                        this.showNoRecycleTips = true;
                    }
                    (<any>this).$edMessage.success(this.$t("recSuccess"));
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                })
                .catch((err) => {
                    this.isOperating = false;
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    if (err == "overLimit") {
                        (<any>this).$edMessage.warning(this.$t("fileLimit"));
                        if (this.isPC) {
                            (<any>window).$qt.jsCallUpdateUpgradeTrigger && (<any>window).$qt.jsCallUpdateUpgradeTrigger("cloudFileNumberLimit");
                            (<any>window).$qt.jsCallNewUpgradeToPremium && (<any>window).$qt.jsCallNewUpgradeToPremium(3);
                            (<any>window).$qt.jsCallUpgradeToPremium && (<any>window).$qt.jsCallUpgradeToPremium(3);
                            (<any>window).$qt.jsCallUploadfailReason && (<any>window).$qt.jsCallUploadfailReason("exceedsCloudFileNumber");
                        } else {
                            this.$store.commit("toPublicStatus", {
                                type: "showUpgrade",
                                data: "fileNum",
                            });
                        }
                    }
                });
        }

        delFile() {
            if (this.isOperating) return;
            this.$track("recycle", "delete file");
            this.isOperating = true;
            this.$store.commit("setState", { data: true, type: "showLoading" });
            let delSuccess = [];
            let ids = [];
            let fileKeys = [];
            for (let i = 0; i < this.selectFilesIndex.length; i++) {
                if (this.isPrivate) {
                    ids.push(this.activeList[this.selectFilesIndex[i]].id);
                    fileKeys.push(this.activeList[this.selectFilesIndex[i]].file_key);
                } else {
                    ids.push(this.activeList[this.selectFilesIndex[i]].info.recycle_id);
                }
                delSuccess.push(this.selectFilesIndex[i]);
            }
            this.$store
                .dispatch("delRecycleFolderBatch", {
                    ids,
                    fileKeys,
                    platform: this.isPC ? "pc" : "web",
                })
                .then((res) => {
                    this.isOperating = false;
                    if (this.searchMode) {
                        this.searchList = this.activeList.filter((v, k) => !ids.includes(v.id));
                        this.filesList = this.filesList.filter((v, k) => !ids.includes(v.id));
                    } else {
                        this.filesList = this.activeList.filter((v, k) => !ids.includes(v.id));
                    }
                    this.clearFile();
                    if (this.folderList.length == 0 && this.activeList.length == 0) {
                        this.showNoRecycleTips = true;
                    }
                    (<any>this).$edMessage.success(this.$t("delSuccess"));
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    this.$bus.$emit("getStorage"); // 刷新使用空间
                })
                .catch((err) => {
                    this.isOperating = false;
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                });
        }
        recycleAllConfirm() {
            this.searchMode = false;
            (<any>this).$Modal.confirm({
                title: this.$t("reAll"),
                content: this.$t("isReAll"),
                cancelText: this.$t("cancel"),
                okText: this.$t("confirm"),
                onOk: () => {
                    this.$track("recycle", "recycle all");
                    this.recycleAll();
                },
                onCancel: () => {},
            });
        }
        recycleAll() {
            let recycleFolderNum = 0;
            if (this.filesList.length > 0 || this.folderList.length > 0) {
                this.$store.commit("setState", { data: true, type: "showLoading" });
            }
            let recFolderFunc = () => {
                this.folderList.forEach((item) => {
                    this.$store
                        .dispatch("recycleFolder", {
                            id: item.id,
                            platform: this.isPC ? "pc" : "web",
                        })
                        .then((res) => {
                            recycleFolderNum++;
                            if (recycleFolderNum == this.folderList.length) {
                                this.folderList = [];
                                (<any>this).$edMessage.success(this.$t("allRecSucc"));
                                this.$store.commit("setState", {
                                    data: false,
                                    type: "showLoading",
                                });
                                if (this.folderList.length == 0 && this.filesList.length == 0) {
                                    this.showNoRecycleTips = true;
                                }
                            }
                            this.clearFile();
                        })
                        .catch((err) => {
                            this.$store.commit("setState", { data: false, type: "showLoading" });
                            if (err == "overLimit") {
                                (<any>this).$edMessage.warning(this.$t("fileLimit"));
                                if (this.isPC) {
                                    (<any>window).$qt.jsCallUpdateUpgradeTrigger &&
                                        (<any>window).$qt.jsCallUpdateUpgradeTrigger("cloudFileNumberLimit");
                                    (<any>window).$qt.jsCallNewUpgradeToPremium && (<any>window).$qt.jsCallNewUpgradeToPremium(3);
                                    (<any>window).$qt.jsCallUpgradeToPremium && (<any>window).$qt.jsCallUpgradeToPremium(3);
                                    (<any>window).$qt.jsCallUploadfailReason && (<any>window).$qt.jsCallUploadfailReason("exceedsCloudFileNumber");
                                } else {
                                    this.$store.commit("toPublicStatus", {
                                        type: "showUpgrade",
                                        data: "fileNum",
                                    });
                                }
                            }
                        });
                });
            };
            let ids = [];
            if (this.filesList.length) {
                for (let i = 0; i < this.filesList.length; i++) {
                    if (this.isPrivate) {
                        ids.push(this.filesList[i].id);
                    } else {
                        ids.push(this.filesList[i].info.recycle_id);
                    }
                }
                this.$store
                    .dispatch("recycleFolderBatch", { ids, platform: this.isPC ? "pc" : "web" })
                    .then((res) => {
                        this.filesList = [];
                        if (this.folderList.length == 0 && this.filesList.length == 0) {
                            this.showNoRecycleTips = true;
                        }
                        if (!this.folderList.length) {
                            this.$store.commit("setState", { data: false, type: "showLoading" });
                        } else {
                            recFolderFunc();
                        }
                    })
                    .catch((err) => {
                        if (err == "overLimit") {
                            (<any>this).$edMessage.warning(this.$t("fileLimit"));
                            if (this.isPC) {
                                (<any>window).$qt.jsCallUpdateUpgradeTrigger && (<any>window).$qt.jsCallUpdateUpgradeTrigger("cloudFileNumberLimit");
                                (<any>window).$qt.jsCallNewUpgradeToPremium && (<any>window).$qt.jsCallNewUpgradeToPremium(3);
                                (<any>window).$qt.jsCallUpgradeToPremium && (<any>window).$qt.jsCallUpgradeToPremium(3);
                                (<any>window).$qt.jsCallUploadfailReason && (<any>window).$qt.jsCallUploadfailReason("exceedsCloudFileNumber");
                            } else {
                                this.$store.commit("toPublicStatus", {
                                    type: "showUpgrade",
                                    data: "fileNum",
                                });
                            }
                        }
                        if (!this.folderList.length) {
                            this.$store.commit("setState", { data: false, type: "showLoading" });
                        } else {
                            recFolderFunc();
                        }
                    });
            } else {
                recFolderFunc();
            }
        }

        recycleClearConfirm() {
            (<any>this).$Modal.confirm({
                title: this.$t("reClear"),
                content: this.$t("isReClear"),
                onOk: () => {
                    this.$track("recycle", "clean recycle");
                    this.recycleClear();
                },
                onCancel: () => {},
            });
        }
        recycleClear() {
            let recycleFolderNum = 0;
            if (this.filesList.length > 0 || this.folderList.length > 0) {
                this.$store.commit("setState", { data: true, type: "showLoading" });
            }
            let ids = [];
            let fileKeys = [];
            if (this.filesList.length) {
                for (let i = 0; i < this.filesList.length; i++) {
                    if (this.isPrivate) {
                        ids.push(this.filesList[i].id);
                        fileKeys.push(this.filesList[i].file_key);
                    } else {
                        ids.push(this.filesList[i].info.recycle_id);
                    }
                }
                this.$store
                    .dispatch("delRecycleFolderBatch", {
                        ids,
                        fileKeys,
                        platform: this.isPC ? "pc" : "web",
                    })
                    .then((res) => {
                        // recycleFileNum++
                        // if (recycleFileNum == this.filesList.length) {
                        this.filesList = [];
                        (<any>this).$edMessage.success(this.$t("cleanSucc"));
                        this.$store.commit("setState", { data: false, type: "showLoading" });
                        if (this.folderList.length == 0 && this.filesList.length == 0) {
                            this.showNoRecycleTips = true;
                        }
                        // }
                        this.clearFile();
                    })
                    .catch((err) => {
                        this.$store.commit("setState", { data: false, type: "showLoading" });
                    });
            }
            this.folderList.forEach((item) => {
                this.$store
                    .dispatch("delRecycleFolder", {
                        id: item.id,
                        platform: this.isPC ? "pc" : "web",
                    })
                    .then((res) => {
                        recycleFolderNum++;
                        if (recycleFolderNum == this.folderList.length) {
                            this.folderList = [];
                            (<any>this).$edMessage.success(this.$t("cleanSucc"));
                            this.$store.commit("setState", { data: false, type: "showLoading" });
                            if (this.folderList.length == 0 && this.filesList.length == 0) {
                                this.showNoRecycleTips = true;
                            }
                        }
                        this.clearFile();
                    })
                    .catch((err) => {
                        this.$store.commit("setState", { data: false, type: "showLoading" });
                    });
            });
        }
        get buyUrl() {
            let url = "";
            if (this.internal) {
                url = "https://www.edrawsoft.cn/order/max_buy.html";
            } else {
                let asd = {
                    en: "https://edrawmax.wondershare.com/store/individuals.html",
                    de: "https://www.edrawsoft.com/de/pricing-edrawmax.html",
                    jp: "https://www.edrawsoft.com/jp/pricing-edrawmax.html",
                    es: "https://www.edrawsoft.com/es/pricing-edrawmax.html",
                    fr: "https://www.edrawsoft.com/fr/pricing-edrawmax.html",
                    it: "https://www.edrawsoft.com/it/pricing-edrawmax.html",
                    pt: "https://www.edrawsoft.com/pt/pricing-edrawmax.html",
                    tw: "https://www.edrawsoft.com/tw/pricing-edrawmax.html",
                    kr: "https://www.edrawsoft.com/kr/pricing-edrawmax.html",
                };
                url = asd[this.lang] || "https://edrawmax.wondershare.com/store/individuals.html";
            }
            return url;
        }
        toVip() {
            this.$openBuyPage("recycleTimeText");
        }
        mounted() {
            if (!["name", "time", "size"].includes(this.orderName)) {
                this.orderName = "time";
            }
            this.$store.commit("setState", { data: 6, type: "selectId" });
            let dom: any = document.querySelector(".recycle-container");
            dom.onscroll = () => {
                this.folderMenuBoxShow = false;
                this.contextmenuBoxShow = false;
            };
            this.$bus.$on("refreshEv", () => {
                this.getRecycleList();
            });
            if (this.userInfo) {
                if (!this.params.islogin) {
                    return;
                }
                this.getRecycleList();
            } else {
                this.$bus.$on("loginSucc-recycle", () => {
                    this.getRecycleList();
                });
            }
            (<any>window).$qt && (<any>window).$qt.jsCallWebUIDisplay && (<any>window).$qt.jsCallWebUIDisplay(); // 通知客户端ui渲染完成
        }

        created() {}
        beforeDestroy() {
            this.selectFilesIndex = [];
            this.contextmenuBoxShow = false;
            this.folderMenuBoxShow = false;
            this.$bus.$off("refreshEv");
            this.$bus.$off("loginSucc-recycle");
        }
    }
</script>

<i18n>
{
  "zh": {
    "switchView": "切换视图",
    "title": "回收站",
    "allFiles": "全部文件",
    "search": "搜索文件",
    "name": "名称",
    "time": "时间",
    "size": "大小",
    "notes": "备注",
    "grid": "网格视图",
    "list": "列表视图",
    "restore": "全部还原",
    "clear": "清空回收站",
    "recover": "恢复",
    "del": "彻底删除",
    "recSuccess": "恢复成功",
    "delSuccess": "删除成功",
    "allRecSucc": "全部恢复成功",
    "cleanSucc": "清空成功",
    "notFind": "没有找到相关文件",
    "notTem": "回收站暂无文件",
    "fileLimit": "云文件数量超过限制，恢复文件失败",
    "reAll": "全部还原",
    "isReAll": "确定还原全部文件？",
    "reClear": "清空回收站",
    "isReClear": "确定清空回收站？",
    "confirm": "确认",
    "cancel": "取消",
    "noVipLimit": "非会员仅可还原7天内删除的文件，",
    "noVipLimitToBuy": "开通VIP可还原90天内删除的文件"
  },
  "en": {
    "switchView": "Switch View",
    "title": "Recycle bin",
    "allFiles": "All Files",
    "search": "Search File",
    "name": "Name",
    "time": "Time",
    "size": "Size",
    "notes": "Remarks",
    "grid": "Grid View",
    "list": "List View",
    "restore": "Restore All",
    "clear": "Empty Recycle Bin",
    "recover": "Restore",
    "del": "Delete",
    "recSuccess": "Restored Successfully ",
    "delSuccess": "Deleted Successfully ",
    "allRecSucc": "All Files Restored Successfully",
    "cleanSucc": "Cleaned Successfully",
    "notFind": "No related files found",
    "notTem": "No documents in the recycle bin",
    "fileLimit": "Restore failed, the amount of your files has reached the upper limit.",
    "reAll": "Restore All",
    "isReAll": "Confirmed to Restore all files ?",
    "reClear": "Empty Recycle Bin",
    "isReClear": "Confirmed to Empty recycle bin ?",
    "confirm": "OK",
    "cancel": "Cancel",
    "noVipLimit": "With the Free version you can only restore documents from the last 7 days. ",
    "noVipLimitToBuy": "Upgrade to Premium to restore documents from the last 90 days."
  },
  "fr": {
    "switchView": "Changer de vue",
    "title": "Corbeille",
    "allFiles": "Tous les documents",
    "search": "Rechercher des fichiers",
    "name": "Nom",
    "time": "Temps",
    "size": "Taille",
    "grid": "Vue grille",
    "list": "Vue liste",
    "restore": "Tout restaurer",
    "clear": "Vider la corbeille",
    "recover": "Récupération",
    "del": "Supprimer complètement",
    "recSuccess": "Restauré avec succès",
    "delSuccess": "Supprimé avec succès",
    "allRecSucc": "Tous récupérés avec succès",
    "cleanSucc": "Réussi avec succès",
    "notFind": "Aucun document connexe trouvé",
    "notTem": "Aucun document dans la corbeille",
    "fileLimit": "Le nombre de fichiers cloud dépasse la limite et la récupération de fichiers échoue",
    "reAll": "Tout restaurer",
    "isReAll": "Déterminez à restaurer tous les fichiers?",
    "reClear": "Vider la corbeille",
    "isReClear": "Voulez-vous vraiment vider la corbeille?",
    "confirm": "Confirmer",
    "cancel": "Annuler"
  },
  "de": {
    "switchView": "Ansicht wechseln",
    "title": "Papierkorb",
    "allFiles": "Alle Dateien",
    "search": "Datei suchen",
    "name": "Name",
    "time": "Zeit",
    "size": "Größe",
    "grid": "Rasteransicht",
    "list": "Listenansicht",
    "restore": "Alles wiederherstellen",
    "clear": "Papierkorb leeren",
    "recover": "Wiederherstellen",
    "del": "Löschen",
    "recSuccess": "Erfolgreich wiederhergestellt",
    "delSuccess": "Erfolgreich gelöscht",
    "allRecSucc": "Alle Dateien erfolgreich wiederhergestellt",
    "cleanSucc": "Erfolgreich geleert",
    "notFind": "Keine verwandten Dateien gefunden",
    "notTem": "Keine Dokumente im Papierkorb",
    "fileLimit": "Wiederherstellung fehlgeschlagen, die Anzahl Ihrer Dateien hat die Obergrenze erreicht",
    "reAll": "Alle wiederherstellen",
    "isReAll": "Bestätigt, um alle Dateien wiederherzustellen?",
    "reClear": "Papierkorb leeren",
    "isReClear": "Bestätigt, Papierkorb zu leeren?",
    "confirm": "Sichern",
    "cancel": "Abbrechen"
  },
  "jp": {
    "switchView": "ビューを切り替える",
    "title": "ゴミ箱",
    "allFiles": "すべてのファイル",
    "search": "ファイルを検索",
    "name": "名前",
    "time": "時間",
    "size": "サイズ",
    "grid": "グリッドビュー",
    "list": "リストビュー",
    "restore": "すべてを元に戻す",
    "clear": "ごみ箱を空にする",
    "recover": "元に戻す",
    "del": "完全に削除",
    "recSuccess": "元に戻しました",
    "delSuccess": "削除されました",
    "allRecSucc": "すべてが元に戻しました",
    "cleanSucc": "空にしました",
    "notFind": "関連ドキュメントは見つかりませんでした",
    "notTem": "ごみ箱にドキュメントがありません",
    "fileLimit": "クラウドファイルの数が制限を超え、ファイルの回復が失敗します",
    "reAll": "すべてを元に戻す",
    "isReAll": "すべてを元に戻しますか？",
    "reClear": "ごみ箱を空にする",
    "isReClear": "ごみ箱を空にしますか？",
    "confirm": "確認",
    "cancel": "キャンセル"
  },
  "es": {
    "switchView": "Cambiar vista",
    "title": "Papelera",
    "allFiles": "Todos los archivos",
    "search": "Buscar archivo",
    "name": "Nombre",
    "time": "Tiempo",
    "size": "Talla",
    "grid": "Vista de cuadrícula",
    "list": "Vista de lista",
    "restore": "Restaurar todo",
    "clear": "Papelera vacía",
    "recover": "Restaurar",
    "del": "Eliminar",
    "recSuccess": "Restaurado exitosamente",
    "delSuccess": "Eliminado exitosamente",
    "allRecSucc": "Todos los archivos restaurados con éxito",
    "cleanSucc": "Limpiado con éxito",
    "notFind": "No se encontraron archivos relacionados",
    "notTem": "No hay documentos en la papelera de reciclaje",
    "fileLimit": "Restauración fallida, la cantidad de sus archivos ha alcanzado el límite superior",
    "reAll": "Restaurar todo",
    "isReAll": "¿Confirmado para vaciar la papelera?",
    "reClear": "Vaciar la papelera.",
    "isReClear": "¿Seguro que quieres vaciar la papelera?",
    "confirm": "Aceptar",
    "cancel": "Cancelar"
  },
  "pt": {
    "switchView": "Trocar Visualização",
    "title": "Pasta de Reciclagem",
    "allFiles": "Todos os Ficheiros",
    "search": "Pesquisar Ficheiro",
    "name": "Nome",
    "time": "Hora",
    "size": "Tamanho",
    "grid": "Visualização em Grelha",
    "list": "Visualização em Lista",
    "restore": "Restaurar Todos",
    "clear": "Esvaziar Pasta de Reciclagem",
    "recover": "Restaurar",
    "del": "Eliminar",
    "recSuccess": "Restaurado com Sucesso",
    "delSuccess": "Eliminado com Sucesso",
    "allRecSucc": "Todos os Ficheiros Restaurados com Sucesso",
    "cleanSucc": "Limpo com Sucesso",
    "notFind": "Não encontrados ficheiros relacionados",
    "notTem": "Nenhum documento na lixeira",
    "fileLimit": "Falha ao restaurar, a quantidade de ficheiros atingiu o limite superior.",
    "reAll": "Restaurar Todos",
    "isReAll": "Confirmar para Restaurar todos os ficheiros?",
    "reClear": "Pasta de Reciclagem Vazia",
    "isReClear": "Confirmar para Esvaziar a pasta de reciclagem?",
    "confirm": "OK",
    "cancel": "Cancelar"
  },
  "it": {
    "switchView": "Cambia Vista",
    "title": "Cestino",
    "allFiles": "Tutti i File",
    "search": "Cerca File",
    "name": "Nome",
    "time": "Ora",
    "size": "Dimensione",
    "grid": "Vista a Griglia",
    "list": "Vista a Elenco",
    "restore": "Ripristina Tutti",
    "clear": "Svuota Cestino",
    "recover": "Ripristina",
    "del": "Elimina",
    "recSuccess": "Ripristino Eseguito con Successo",
    "delSuccess": "Eliminazione Eseguita con Successo",
    "allRecSucc": "Tutti i File Sono Stati Ripristinati con Successo",
    "cleanSucc": "Il Cestino è Stato Svuotato",
    "notFind": "Nessun file trovato",
    "notTem": "Nessun documento nel cestino",
    "fileLimit": "Ripristino fallito. È stato raggiunto il numero massimo di file.",
    "reAll": "Ripristina Tutti",
    "isReAll": "Confermi di voler ripristinare tutti i file?",
    "reClear": "Svuota Cestino",
    "isReClear": "Confermi di voler svuotare il cestino?",
    "confirm": "OK",
    "cancel": "Annulla"
  },
  "tw": {
    "switchView": "切換視圖",
    "title": "回收站",
    "allFiles": "全部檔案",
    "search": "搜索檔案",
    "name": "名稱",
    "time": "時間",
    "size": "大小",
    "grid": "網格視圖",
    "list": "列表視圖",
    "restore": "全部還原",
    "clear": "清空回收站",
    "recover": "恢復",
    "del": "徹底刪除",
    "recSuccess": "恢復成功",
    "delSuccess": "刪除成功",
    "allRecSucc": "全部恢復成功",
    "cleanSucc": "清空成功",
    "notFind": "沒有找到相關檔案",
    "notTem": "資源回收筒中沒有文件",
    "fileLimit": "雲端硬碟檔案數量超過限制，恢復檔案失敗",
    "reAll": "全部還原",
    "isReAll": "確定還原全部檔案？",
    "reClear": "清空回收站",
    "isReClear": "確定清空回收站？",
    "confirm": "確認",
    "cancel": "取消"
  },
  "kr": {
    "switchView": "보기 전환",
    "title": "휴지통",
    "allFiles": "모든 파일",
    "search": "파일 검색",
    "name": "이름",
    "time": "시간",
    "size": "크기",
    "grid": "그리드보기",
    "list": "목록보기",
    "restore": "모두 복원",
    "clear": "휴지통 비우기",
    "recover": "복구",
    "del": "삭제하기",
    "recSuccess": "복구 성공",
    "delSuccess": "삭제 성공",
    "allRecSucc": "전부 회복 성공",
    "cleanSucc": "비우기 성공",
    "notFind": "해당 파일을 찾을 수 없습니다",
    "notTem": "휴지통에 문서 없음",
    "fileLimit": "클라우드 파일 수가 제한을 초과하여 파일 복구가 실패했습니다.",
    "reAll": "모두 복원",
    "isReAll": "모든 파일을 복원 하시겠습니까?",
    "reClear": "휴지통 비우기",
    "isReClear": "휴지통을 비우시겠습니까?",
    "confirm": "확인 ",
    "cancel": "취소 "
  },
  "id": {
    "switchView": "Ganti Tampilan",
    "title": "Tempat sampah",
    "allFiles": "Semua File",
    "search": "Cari File",
    "name": "Nama",
    "time": "Waktu",
    "size": "Ukuran",
    "grid": "Tampilan Kisi",
    "list": "Tampilan Daftar",
    "restore": "Pulihkan Semua",
    "clear": "Kosongkan Tempat Sampah",
    "recover": "Pulihkan",
    "del": "Hapus",
    "recSuccess": "File Berhasil Dipulihkan ",
    "delSuccess": "File Berhasil Dihapus ",
    "allRecSucc": "Semua File Berhasil Dipulihkan",
    "cleanSucc": "Berhasil Dibersihkan",
    "notFind": "File terkait tidak ditemukan",
    "notTem": "Tidak ada dokumen di keranjang sampah",
    "fileLimit": "Pemulihan gagal. Jumlah file Anda telah mencapai batas maksimum.",
    "reAll": "Pulihkan Semua",
    "isReAll": "Konfirmasi untuk Memulihkan semua file?",
    "reClear": "Kosongkan Tempat Sampah",
    "isReClear": "Konfirmasi untuk mengosongkan tempat sampah?",
    "confirm": "OKE",
    "cancel": "Batalkan"
  }
}
</i18n>
